import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash-es';

@Pipe({
  name: 'orderBy',
  standalone: false
})
export class OrderByPipe implements PipeTransform {
  public transform(list: Record<string, any>, iteratees?: string | string[], orders?: boolean | 'asc' | 'desc' | (boolean | 'asc' | 'desc')[]): unknown {
    return orderBy(list, iteratees, orders);
  }
}
